/**
 * @file The purchase album faces view.
 */

import React from 'react';

import PurchaseAlbumFacesContainer from '../../containers/purchase/PurchaseAlbumFacesContainer';

const PurchaseAlbumFacesView = () => <PurchaseAlbumFacesContainer />;

export default PurchaseAlbumFacesView;
